export default "__VITE_ASSET__HiF7UkvV__"